import { Publishing } from '../models/publishing';

export const GLOBAL = {
  url: 'http://localhost/curso-angular4-backend/index.php/',
  header_color: '#E03137',
  confPublishingGooglePlay: new Publishing('Google Play', '', '/assets/images/googlePlayStore.png'),
  confPublishingWindowsPhone: new Publishing('Windows Phone', '', '/assets/images/windowsPhoneStore.png'),
  confPublishingAppleStore: new Publishing('Apple Store', '', '/assets/images/appleStore.png'),
  confPublishingAmazon: new Publishing('Amazon', '', '/assets/images/amazon-app-store.png'),
  confPublishingGalaxyApps: new Publishing('Samsung Galaxy Apps', '', '/assets/images/samsunggalaxy.png'),
  confPublishingNaranya: new Publishing('Naranya', '', '/assets/images/naranya.jpg'),
  confPublishingGetjar: new Publishing('Getjar', '', '/assets/images/getjar.jpg'),
  confPublishingWeb: new Publishing('Web', '', '/assets/images/availableonweb.png')
};
